<dxp-expand-link expand-link-id="mc-search-filter" collapse-text="Filter" expand-text="Filter" content=""
    aria-label="Click on the link to open filter options" [expanded]="this.expandedState" (toggleExpandEvent)="expandedEvent($event)">
    <div class="dxp-row dxp-bg-initial float">
        <form [formGroup]="this.filterForm">
            <div class="dxp-bg-initial" padding-style-sm="24px 24px">
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1" padding-style-sm="24px 0px 16px 0px">
                        <dxp-link type="dxp-btn-custom-link" text="Clear filters" aria-label="Click on the link to clear filters"
                            (click)="this.clearFilters()"></dxp-link>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
                <p class="status-label">Status</p>
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1">
                        <dxp-radio-group input-id="content" alignment="horizontal" name="filterOptions" required="true"
                            validation-message="Please select filter option." (radioSelected)="setSelectedStatus($event)">
                            <dxp-radio-button name="filterOptions" #radioOptions *ngFor="let status of this.requestStatus" [label]="status.description" [radioKey]="status.id" [value]="status.id"
                                aria-label="{{'Filter by ' + status.description + 'requests'}}" [checked]="(status.id == 1) ? true: false" id="{{status.description.toLowerCase() + 'RadioButton'}}">
                            </dxp-radio-button>
                        </dxp-radio-group>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
                <dxp-flex-layout [hidden]="!this.isDateRangeVisible">
                    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="0px 0px">
                        <date-range class="dateComponent" (selectedFromDate)="setSelectedFromDate($event)"
                            (selectedToDate)="setSelectedToDate($event)" (defaultDates)="fillDefaultDates($event)"
                            [isRequired]="true" [parentForm]="this.filterForm" [intervalDays]="1"
                            [submitted]="this.submitted" #dateRange></date-range>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1" column-width-sm="6" [paddingStyleSm]="(this.isDateRangeVisible)?'24px 16px 0px 0px': '0px 0px'">
                        <dxp-multi-selector selector-id="requesters" data-source-key-name="description"
                            [items]="this.requesters" max-limit="1"
                            search-placeholder="{{msg.PlaceHolders.SelectOptions}}"
                            placeholder="{{msg.PlaceHolders.SelectOptions}}" label="Requester" optional=true
                            (selectedOptions)="setSelectedRequester($event)" multi-search="true" max-limit="1"
                            list-aria-label="Requester dropdown" [value]="this.selectedRequesterValue?.description" #requestersReference>
                        </dxp-multi-selector>
                    </dxp-flex-layout-item>
                    <dxp-flex-layout-item slot="column-2" column-width-sm="6" padding-style-sm="24px 16px 0px 0px">
                        <dxp-multi-selector [hidden]="!this.showActionTakenBy" selector-id="action-taken-by" data-source-key-name="description"
                            [items]="this.approvers" max-limit="1"
                            search-placeholder="{{msg.PlaceHolders.SelectOptions}}"
                            placeholder="{{msg.PlaceHolders.SelectOptions}}" label="Action taken by" optional=true
                            (selectedOptions)="setSelectedActionTakenBy($event)" multi-search="true" max-limit="1"
                            list-aria-label="Action taken by dropdown" [value]="this.selectedActionTakenByValue?.description" #actionTakenByReference>
                        </dxp-multi-selector>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
                <dxp-flex-layout>
                    <dxp-flex-layout-item slot="column-1" column-width-sm="6" padding-style-sm="40px 0px">
                        <dxp-button type="primary" button-id="btnApplyFilter" text="Apply filters" [state]="this.submitted"
                            aria-label="Click to apply filters" button-title="Apply filters" (ctaClickEvent)="applyFilter()">
                        </dxp-button>
                    </dxp-flex-layout-item>
                    <dxp-flex-layout-item slot="column-2" column-width-sm="6"
                        padding-style-sm="40px 0px">
                        <dxp-button type="secondary" button-id="btnCancel" text="Cancel" state="enabled"
                            aria-label="Click to cancel and close the filter form" button-title="Cancel" (ctaClickEvent)="cancel()">
                        </dxp-button>
                    </dxp-flex-layout-item>
                </dxp-flex-layout>
            </div>
        </form>
    </div>
</dxp-expand-link>